import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const bookStockList = createAsyncThunk('book-stock-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-book/stock-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const addBookToStock = createAsyncThunk('add-book-to-stock', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}school-book/add-book-to-stock`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const editBookToStock = createAsyncThunk('edit-book-stock', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-book/edit-book-stock/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type BookState = {
  errors: any
}

const initialState: BookState = {
  errors: '',
}

export const bookStockSlice = createSlice({
  name: 'book-stock',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(addBookToStock.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = bookStockSlice.actions
export default bookStockSlice.reducer
